import {
  TechnicalCardDetail,
  TechnicalCardValues,
} from './TechnicalCardsPage/services';
import { ConfirmDialogModal } from 'src/components/MainPage/_shared/ConfirmDialog/ConfirmDialog';

export const mapTechnicalCardToValues = (
  detail: TechnicalCardDetail
): TechnicalCardValues => ({
  nomenclatureId: detail.nomenclatureId,
  type: detail.type,
  yieldQuantity: detail.yieldQuantity,
  shopId: detail.shopId,
  yieldTransformNomenclatureId: detail.yieldTransformNomenclatureId,
  yieldTransformQuantity: detail.yieldTransformQuantity,
  items: detail.items.map((item) => {
    return {
      ...item,
      nomenclatureId: item.nomenclatureId ?? item.nomenclature?.id ?? '',
      weightPerUnit:
        item.weightPerUnit ?? item.nomenclature?.weightPerUnit ?? 0,
      baseUnitOfMeasurement: item.unitOfMeasurement,
      baseWeightPerUnit:
        item.weightPerUnit || item.nomenclature?.weightPerUnit || 0,
    };
  }),
  nomenclature: null,
  shop: detail.shopId ? { id: detail.shopId, name: '' } : null,
  yieldTransformNomenclature: null,
  number: detail.number,
  isDefault: detail.isDefault,
});

export const cloneTechnicalCardWithConfirm = (
  values: TechnicalCardValues,
  cloneMutation: { mutate: (values: TechnicalCardValues) => void }
) => {
  ConfirmDialogModal({
    title: 'Клонировать технологическую карту?',
    contentText:
      'Эта операция позволяет дублировать технологическую карту. Все технологические параметры будут также скопированы. Вы действительно хотите продолжить?',
  }).then((shouldClone) => {
    if (shouldClone) {
      const payload: TechnicalCardValues = {
        ...values,
        number: '',
        isDefault: false,
        items: values.items.map((item) => ({
          ...item,
          id: undefined,
        })),
      };
      cloneMutation.mutate(payload);
    }
  });
};

export const generateId = () =>
  `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;

export const roundToFour = (num: number) => Number(num.toFixed(4));
